// Bearer token store. localStorage (not sessionStorage): voters vote from their
// OWN phones, where sessionStorage was losing the session constantly — it is
// per-tab, so re-scanning the QR (a new tab) or iOS discarding a backgrounded
// tab logged the voter out mid-flow. Parity with the Flutter app, which keeps
// the same token in FlutterSecureStorage across restarts. The shared-kiosk
// argument for sessionStorage does not apply here, and signOut() still clears
// everything. In-memory cache dodges read-after-write timing. Client-only.

const KEY = "bearer_token";
let cache: string | null = null;

export function getToken(): string | null {
  if (cache !== null) return cache;
  if (typeof window === "undefined") return null;
  cache = window.localStorage.getItem(KEY);
  return cache;
}

export function saveToken(token: string): void {
  cache = token;
  if (typeof window !== "undefined") window.localStorage.setItem(KEY, token);
}

export function clearToken(): void {
  cache = null;
  if (typeof window !== "undefined") {
    window.localStorage.removeItem(KEY);
    // Leftover from when the bearer lived in sessionStorage: without this a
    // stale copy there outlives the sign-out on a device that ran both builds.
    window.sessionStorage.removeItem(KEY);
  }
}
